import React from 'react';
import './IconText.css';

const IconText = () => (
    <div className='iconTextContainer'>
      <span className='capitalizedIconText'>J</span>
      u
      <span className='capitalizedIconText'>D</span>ev
    </div>
);

export default IconText;
